import i18next from "i18next";
import * as agesServices from "../../services/ageServices";
import { useEffect, useState } from "react";
import Autocomplete from "../../components/Autocomplete";
import MultiSelect from "../../components/MultiSelect";
import useDebouncedFunction from "../../hooks/useDebouncedFunction";

interface AgesSelectProps {
	value?: any;
	showValue?: any;
	onChange?: any;
	error?: any;
	multiple?: boolean;
	required?: boolean;
}

const AgeSelect = ({ multiple, value, showValue, onChange, error, required }: AgesSelectProps) => {
	const [ages, setAges] = useState<any>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!showValue) {
			handleChangeSearch({ target: { value: "" } });
		}
	}, [showValue]);

	const handleChangeSearch = async (e: any) => {
		const value = e?.target?.value ?? "";

		setLoading(true);
		var ages = await agesServices.search({ skip: 0, limit: 10, search: value });
		ages = ages.result.map((age) => ({
			label: age.name,
			value: age,
			...age,
		}));
		setAges(ages);
		setLoading(false);
	};

	const debouncedSearch = useDebouncedFunction(handleChangeSearch);

	if (multiple)
		return (
			<MultiSelect
				options={ages.filter((g) => !value.map((g) => g.id).includes(g.id))}
				placeholder={i18next.t("entity-search", { entity: i18next.t("Age") })}
				datatestid={"search-age-input"}
				label={i18next.t("ages")}
				value={value}
				onInputChange={(e) => {
					setLoading(true);
					debouncedSearch(e);
				}}
				renderValue={(value) => <div>{value.map(({ name }) => name).join(", ")}</div>}
				showValue={showValue}
				onChange={onChange}
				error={error}
				loading={loading}
				required={required}
			/>
		);

	return (
		<Autocomplete
			error={error}
			className="mt-3"
			id="age"
			onInputChange={(e) => {
				setLoading(true);
				debouncedSearch(e);
			}}
			options={ages}
			datatestid={"search-age-input"}
			onChange={onChange}
			placeholder={i18next.t("entity-search", { entity: i18next.t("Age") })}
			label={i18next.t("age")}
			value={value}
			showValue={showValue}
			renderValue={(value) => <div>{value.name}</div>}
			loading={loading}
			required={required}
		/>
	);
};

export default AgeSelect;
